import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { navItems } from "@/constants/nav";

function resolveActive(pathname: string): string {
  const seg = pathname.split("/").filter(Boolean);
  if (seg[0] === "detail" && seg[1]) {
    if (seg[1] === "video") return "/video";
    if (seg[1] === "encyclopedia") return "/encyclopedia";
    if (seg[1] === "news") return "/news";
  }
  if (seg.length === 0) return "/";
  return `/${seg[0]}`;
}

export default function SiteHeader() {
  const { pathname } = useLocation();
  const active = resolveActive(pathname);
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="flex h-16 w-full items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2" aria-label="百度一下 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-black text-background-50">
            百
          </span>
          <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
            百度一下
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => {
            const isActive = active === item.to;
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`rounded-md px-3 py-2 text-sm whitespace-nowrap transition-colors ${
                  isActive
                    ? "bg-primary-100 font-medium text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 md:hidden"
          aria-label="展开导航菜单"
          aria-expanded={open}
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-2 md:hidden">
          <nav className="flex flex-col" aria-label="移动端导航">
            {navItems.map((item) => {
              const isActive = active === item.to;
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setOpen(false)}
                  className={`flex items-center justify-between rounded-md px-3 py-3 text-sm ${
                    isActive ? "bg-primary-100 font-medium text-primary-700" : "text-foreground-800"
                  }`}
                >
                  <span>{item.label}</span>
                  <i className="ri-arrow-right-s-line text-lg text-foreground-400" />
                </Link>
              );
            })}
          </nav>
        </div>
      )}
    </header>
  );
}